import { Skeleton } from '@sara/ui/components/skeleton';

export function RubricFormSkeleton() {
  return (
    <div className="space-y-5">
      <Skeleton className="h-32 rounded-lg" />
      <Skeleton className="h-72 rounded-lg" />
      <Skeleton className="h-72 rounded-lg" />
    </div>
  );
}
